import InfoPage from "@/pages/InfoPage";

export default function PrivacyNotice() {
  return (
    <InfoPage
      testId="privacy-notice-page"
      eyebrow="Important Information"
      title="Privacy Notice"
      intro="AGS Cleaning Services is committed to protecting the personal data of our clients, employees, applicants, and website visitors. This notice explains what we collect, why we collect it, and your rights under the EU GDPR and the Irish Data Protection Act 2018."
      sections={[
        {
          heading: "1. Who we are",
          body: "AGS Cleaning Services is a family-owned commercial cleaning company operating across the Republic of Ireland. For privacy matters, you can contact us at info@ags-services.ie.",
        },
        {
          heading: "2. What data we collect",
          body: "We collect only the data necessary to deliver our services and respond to your enquiries:",
          list: [
            "Identity: full name, role/position, employer name",
            "Contact: email, phone number, business address",
            "Site information: site type, square footage, scope details you provide",
            "Job-application data: CV, work history, location, right-to-work indicators",
            "Technical: anonymised usage data via cookies (see Cookie Policy)",
          ],
        },
        {
          heading: "3. Why we collect it (lawful bases)",
          body: "We process personal data on the following lawful bases:",
          list: [
            "Contract — to issue quotations, deliver services, and process job applications",
            "Legitimate interest — to maintain client relationships and improve our services",
            "Legal obligation — Revenue, Workplace Relations Commission, insurance",
            "Consent — for marketing communications you actively opt in to",
          ],
        },
        {
          heading: "4. How we store it",
          body: "Data is held within the EU on secured infrastructure with restricted access. Quotation enquiries are retained for up to 24 months; unsuccessful job applications are deleted after 12 months unless you ask us to keep them on file.",
        },
        {
          heading: "5. Your rights",
          body: "Under GDPR you have the right to access, rectify, erase, restrict, or port your personal data, and to object to processing. To exercise these rights, email info@ags-services.ie. We respond within 30 calendar days.",
        },
        {
          heading: "6. Complaints",
          body: "If you believe your data has been mishandled, you may lodge a complaint with the Data Protection Commission of Ireland (dataprotection.ie).",
        },
      ]}
    />
  );
}
